async function sendAjaxDataToWP(data) {
  try {
    const response = await fetch("/wp-admin/admin-ajax.php", {
      method: "POST",
      body: data,
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `HTTP error! status: ${response.status}, details: ${errorText}`
      );
    }
    const responseJson = await response.json();
    if (responseJson.success === true) {
      //console.log("Success:", responseJson.data);
      return responseJson.data;
    } else {
      //console.error("WordPress Error:", responseJson.data);
      throw new Error(responseJson.data || "WordPress AJAX request failed");
    }
  } catch (error) {
    console.error("Fetch Error:", error);
    throw error;
  }
}

export { sendAjaxDataToWP };
